const dataSourceTypesReducer = (state = [], action) => {
  switch (action.type) {
    case 'LANDSHARK_DATA_SOURCE_TYPES':
      return action.results;
    default:
      break;
  }
  return state;
}

export default dataSourceTypesReducer;

